// extracted by mini-css-extract-plugin
module.exports = {"assets":"AssetsPage_assets_RJ9R8","assetTitle":"AssetsPage_assetTitle_2P0F_"};